import { Radio, Space } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getTAFFundMedications } from '../SpecialRules/TAFSpecialRules';
import './RadioInputStyle.css';

const TAFFundMedications = props => {
    const { def, data, onChange, state } = props;
    const { getThenResolver } = props;
    const [fundMeds, setFundMeds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFundMeds() {
            const meds = await getTAFFundMedications(getThenResolver, ctx.meta.assistanceProgramId);
            setFundMeds(meds);
        };

        loadFundMeds();
        
    }, []);

    const selectedFund = ctx.formData['TAF Fund Selection'];

    if (!fundMeds || !selectedFund) return null;

    return <Radio.Group
        value={data}
        onChange={(e) => { if (!state.readonly) onChange(def.dataKey, e.target.value) }}
        data-input={'taffundmedicationsinput_de'}
    >
        <Space direction='vertical'>
            {fundMeds.find(f => f.fundName === selectedFund)?.medications.map(med => {
                const label = med.name;
                const val = med.value;

                return <Radio value={val} style={{ color: 'black !important' }}>{label}</Radio>
            })}
        </Space>
    </Radio.Group>
}

export default WithDataFetcher(TAFFundMedications);
